import { action, makeObservable, observable } from 'mobx';

import {
  SettlementLineItemGroup,
  SettlementPresentation,
} from '~hooks/useSettlementLineItems/models';

export default class SettlementLineItemsStore {
  settlementLineItemGroupsBySettlementId: Record<string, SettlementLineItemGroup[]> = {};

  presentationBySettlementId: Record<string, SettlementPresentation> = {};

  constructor() {
    makeObservable(this, {
      settlementLineItemGroupsBySettlementId: observable,
      presentationBySettlementId: observable,
      setPresentationBySettlementId: action,
    });
  }

  setPresentationBySettlementId(
    settlementId: string,
    presentation: SettlementPresentation,
  ) {
    this.presentationBySettlementId[settlementId] = presentation;
  }

  setSettlementLineItemGroupsBySettlementId(
    settlementId: string,
    settlementLineItemGroups: SettlementLineItemGroup[],
  ) {
    this.settlementLineItemGroupsBySettlementId[settlementId] = [
      ...settlementLineItemGroups,
    ];
  }
}
